<!-- <app-header></app-header>
<div class="container2">


      <section class="dashboard-card-itinerary">

            <app-itinenary-list class="itinerary"></app-itinenary-list>

            <div>
                  <app-itinerary-route class="route"></app-itinerary-route>
            </div>

           

            <div >
                
                        <mat-expansion-panel class="dashboard-card-import">
                              <mat-expansion-panel-header> 
                                    <mat-panel-title (click)="openImportDialog()">File Import / Export</mat-panel-title>
                              </mat-expansion-panel-header>
                        </mat-expansion-panel>
                 
                  
            </div> -->

<!-- <app-file-import class="dashboard-card-import"></app-file-import>  -->

<!-- </section>  -->

<!-- DISPLAY RENDERED MAP  -->
<!-- <app-render-map class="dashboard-card-map" [coordinates]="coordinates"></app-render-map>
</div>  -->
<div class="container3">

      <div class="container4">
            <div class="banner">
                  <app-header></app-header>
            </div>
            <div class="itenary">
                  <app-itinenary-list class="itinerary"></app-itinenary-list>
            </div>
            <div class="route">
                  <app-itinerary-route class="route"></app-itinerary-route>
            </div>
            <div class="import">
                  <app-file-import class="dashboard-card-import"></app-file-import>
            </div>
            <div  class="export">
                  <button   class="exportButton" (click)="openExportDialog()">Export</button>
            </div>
            <div *ngIf="this.profileId == 1" class="user">
                  <button class="addUserButton" (click)="openAddUser()">Users</button>
            </div>
            <div *ngIf="this.profileId == 1" class="audit">
                  <button class="auditTrailButton" (click)="openAuditTrail()">Audit Trail</button>
            </div>            
      </div>
      <div class="container5">
            <div class="map">
                  <!-- DISPLAY RENDERED MAP  -->
                  <app-render-map class="dashboard-card-map" [coordinates]="coordinates"></app-render-map>
            </div>
      </div>

</div>